import { render, staticRenderFns } from "./SuperAdminModuleSubSettings.vue?vue&type=template&id=6daf5006&"
import script from "./SuperAdminModuleSubSettings.vue?vue&type=script&lang=js&"
export * from "./SuperAdminModuleSubSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports